module.exports = __webpack_public_path__ + "img/csr_110923_E.ea23b8c4.jpg";